import axios from 'axios'
import { showToast } from 'components/Notification/ToastNotification'

const axiosInstance = axios.create()

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear()
      showToast(
        `La sesión ha expirado por vencimiento de tiempo o porque se cerró en otro navegador.`,
        'error',
      )
      setTimeout(function () {
        window.location.reload()
      }, 3000)
    } else {
      return Promise.reject(error)
    }
  },
)

export default axiosInstance
